import Vue from 'vue';
import VueRouter from 'vue-router';

const PageDown = () => import('@/pages/p-down');
const PageNormal = () => import('@/pages/p-normal');
const PageImg = () => import('@/pages/p-img');
const PageVideo = () => import('@/pages/p-video');

Vue.use(VueRouter);

export default new VueRouter({
    // mode: 'history',
    routes: [
        {path: '/download', component: PageDown},
        {path: '/normal/:id', component: PageNormal},
        {path: '/image/:id', component: PageImg},
        {path: '/video/:id', component: PageVideo}
    ],
    scrollBehavior(to, from, savedPosition) {
        if(savedPosition) {
            return savedPosition;
        } else {
            const position = {};
            if(to.hash) {
                position.selector = to.hash;
            }
            if(to.matched.some(m => m.meta.scrollToTop)) {
                position.x = 0;
                position.y = 0;
            }
            return position;
        }
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js